import React, { useState } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { SearchOutlined } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";

const Search = ({ getFiltered }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filtered, setFiltered] = useState(searchParams.get("search"));

  const { handleSubmit } = useForm();

  const handleNewData = () => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (filtered) {
        next.set("search", filtered);
      } else {
        next.delete("search");
      }

      next.set("page", "1");
      return next;
    });
    getFiltered.reFetch();
  };

  return (
    <form onSubmit={handleSubmit(handleNewData)} className="flex items-center">
      <TextField
        id="outlined-search"
        label="جستجو"
        type="search"
        onChange={(e) => setFiltered(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            "&:hover": {
              "& fieldset": {
                borderColor: "rgb(var(--c-primary))",
              },
            },
            "&.Mui-focused": {
              "& fieldset": {
                borderColor: "rgb(var(--c-primary))",
              },
            },
          },
          "& label.Mui-focused": {
            color: "rgb(var(--c-primary))",
          },
        }}
        value={filtered}
      />
      <button
        type="submit"
        className={`text-white !bg-primary hover:bg-primary-hover transition-all rounded-16 active:bg-primary-active focus:outline-none font-normal text-base rounded-l-card w-fit py-md px-8  `}
      >
        <SearchOutlined />
      </button>
    </form>
  );
};

export default Search;
